<template>
    <div class="hamburger">
        <label @click="toggle()">
            <svg class="menu-icon"><use xlink:href="#burger-menu"></use></svg>
        </label>
        <div class="menu-content">

            <label class="menu-button-close"  @click="toggle()">
                <svg class="menu-icon"><use xlink:href="#close"></use></svg>
            </label>

            <div class="menu-items">
                <a href="/destinations" class="hide-lg">Explore Destinations</a>
                <a href="/about">About Us</a>
                <a href="/faqs">FAQ</a>
            </div>

            <div class="social-media">
                <a target="_blank" href="https://www.instagram.com/welltraveledclub/">Instagram</a>
                <a target="_blank" href="https://www.tiktok.com/@welltraveledclub">TikTok</a>
                <a target="_blank" href="https://www.linkedin.com/company/welltraveledclub">LinkedIn</a>
            </div>
        </div>
        <div class="destinations-dropdown">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {

    data(){
        return{
            menuIsOpen: false,
            destinationMenuIsOpen : false,
        }
    },

    mounted() {
        $('.destinations-dropdown .menu-button-close').on('click', () => {
            this.closeDestinations()
        })
    },

    methods: {

        toggle() {
            $('.hamburger .menu-content').fadeToggle();
            this.menuIsOpen = !this.menuIsOpen;
            this.stackBodyScroll()
        },

        openDestinations() {
            this.toggle()
            $('.hamburger .destinations-dropdown .dropdown-content').fadeToggle();
            this.destinationMenuIsOpen = true
            this.stackBodyScroll()
        },

        closeDestinations() {
            this.destinationMenuIsOpen = false
            $('.destinations-dropdown .dropdown-content').fadeToggle();
            this.stackBodyScroll()
        },

        stackBodyScroll() {
            if (this.menuIsOpen || this.destinationMenuIsOpen) {
                $('body').css({
                    overflow: 'hidden',
                    maxHeight: '100vh',
                })
            } else {
                $('body').css({
                    overflow: 'auto',
                    maxHeight: 'inherit',
                })
            }
        }
    }
}
</script>
